/* eslint-disable react/prop-types */
import { Cancel } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import BusinessIcon from "@mui/icons-material/Business";
import ArticleIcon from "@mui/icons-material/Article";
import {
  Alert,
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  ListItemIcon,
  MenuItem,
  Select,
  Snackbar,
  Stack,
  Tab,
  Tabs,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useEffect, useMemo, useRef, useState } from "react";
import CustomFieldForm from "../../components/CustomFieldForm";
import {
  API_URL,
  MenuProps,
  PaperComponent,
  validateArrayFileRequired,
} from "../../utils/constants";
import dayjs from "dayjs";
import CancelIcon from "@mui/icons-material/Cancel";
import { JsonTool } from "utils/jsonTools";
import CustomTabPanel from "components/CustomPanel/customPanel";
import AddListFile from "components/AddListFile";
import theme from "assets/theme";
import { useRecoilValue } from "recoil";
import { SettingState } from "states";
import { LinkImage } from "../../utils";
const defaultValue = {
  soquyetdinh: "",
  ngayky: null,
  coquanky: "",
  capquanly: 1,
  trichyeu: "",
  loai: 1,
  trangthai: 1,
  thanhvien: null,
  maquan: null,
  maphuong: null,
};

const FormHoiDong = ({
  data,
  open,
  onClose,
  onSubmit,
  title,
  validationErrors,
  action,
  dataThanhVien,
  dataHuyen,
}) => {
  // state lỗi giá trị từ form
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const formRef = useRef(null);
  const [errors, setErrors] = useState();
  const [dataState, setDataState] = useState(defaultValue);
  const [value, setValue] = useState(0);
  const [alert, setAlert] = useState({
    alert: false,
    message: null,
    type: null,
  });
  //state file
  const [fileDel, setFileDel] = useState([]);
  const [fileFields, setFileFields] = useState([]);
  const [fileEditName, setFileEditName] = useState({});
  const settingState = useRecoilValue(SettingState);

  const handleChangeDistrict = (e) => {
    const value = e.target.value;
    setDataState((prev) => {
      return {
        ...prev,
        maquan: value,
      };
    });
  };
  const fieldInfor = useMemo(() => {
    let result = [
      {
        name: "Quận huyện",
        key: "maquan",
        type: "select",
        onChange: handleChangeDistrict,
        unicode: "ma",
        required: true,
        hasPlaceholder: true,
        labelKeyOption: "ten",
        xs: 12,
        md: 12,
        lg: 12,
      },
      {
        name: "Số quyết định",
        key: "soquyetdinh",
        type: "text",
        required: true,
        maxLength: 255,
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        name: "Ngày ký",
        key: "ngayky",
        type: "date",
        required: true,
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        name: "Cơ quan ký",
        key: "coquanky",
        type: "text",
        maxLength: 255,
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        name: "Cấp quản lý",
        key: "capquanly",
        type: "select",
        unicode: "id",
        required: true,
        hasPlaceholder: true,
        labelKeyOption: "ten",
        xs: 12,
        md: 3,
        lg: 3,
      },
      {
        name: "Loại",
        key: "loai",
        type: "select",
        unicode: "id",
        required: true,
        hasPlaceholder: true,
        labelKeyOption: "ten",
        xs: 12,
        md: 3,
        lg: 3,
      },
      {
        name: "Trích yếu",
        key: "trichyeu",
        type: "textArea",
        required: true,
        maxLength: 255,
        xs: 12,
        md: 9,
        lg: 9,
      },
      {
        name: "Trạng thái",
        key: "trangthai",
        type: "select",
        unicode: "id",
        required: true,
        hasPlaceholder: true,
        labelKeyOption: "ten",
        xs: 12,
        md: 3,
        lg: 3,
      },
    ];
    return result;
  }, []);

  useEffect(() => {
    if (data?.id) {
      setDataState(data);
    } else {
      setDataState(defaultValue);
    }
  }, [data]);

  async function onSubmitForm(event) {
    event.preventDefault();
    const _data = { ...dataState };
    if (action == "Edit") {
      delete _data["tepdinhkem_hoidong"];
      _data["fileDel"] = fileDel;
      _data["id"] = data?.id;
      _data["rowIndex"] = data?.rowIndex;
    }
    const listFormatDate = ["ngayky"];
    listFormatDate?.forEach((field) => {
      _data[field] =
        dataState?.[field] &&
        !errors?.[field] &&
        dayjs(dataState?.[field])?.isValid()
          ? new Date(dataState?.[field])?.toISOString()
          : null;
    });
    _data["tentepdinhkem"] = fileFields?.map((item) => item?.filename) || [];
    _data["tepdinhkemValidate"] = fileFields?.map((item) => item?.file) || [];
    _data["tentepdinhkemEdit"] = Object.values(fileEditName);
    const newValidationErrors = validateOBJ(
      _data,
      settingState["dungluong_file_upload"]
    );
    let _tempValid = newValidationErrors;
    if (
      _tempValid["tepdinhkemValidate"] &&
      _tempValid["tepdinhkemValidate"].some((error) => error)
    ) {
      setErrors(newValidationErrors);
      return;
    }
    if (
      _tempValid["tentepdinhkem"] &&
      _tempValid["tentepdinhkem"].some((error) => error)
    ) {
      setErrors(newValidationErrors);
      return;
    }

    if (
      _tempValid["tentepdinhkemEdit"] &&
      Object.values(_tempValid["tentepdinhkemEdit"])?.length > 0 &&
      Object.values(_tempValid["tentepdinhkemEdit"]).some((error) => error)
    ) {
      setErrors(newValidationErrors);
      return;
    }

    delete _tempValid["tentepdinhkem"];
    delete _tempValid["tepdinhkemValidate"];
    delete _tempValid["tentepdinhkemEdit"];
    delete _data["tepdinhkemValidate"];
    if (Object.values(_tempValid).some((error) => error)) {
      setErrors((prev) => ({
        ...prev,
        ...newValidationErrors,
      }));
      return;
    }
    // Chuyển đổi tất cả tập tin sang base64
    let jsonPayload = [];
    if (fileFields && fileFields?.length > 0) {
      const promises = [];
      fileFields?.forEach((item) => {
        if (!item?.remove) {
          let json = JsonTool.convertToBase64(item?.file);
          promises.push(json);
        }
      });
      jsonPayload = await Promise.all(promises);
    }
    let listName = [];
    fileFields?.forEach((item) => {
      if (!item?.remove) {
        listName.push(item?.filename);
      }
    });
    let listFileName = [];
    fileFields?.forEach((item) => {
      if (!item?.remove) {
        listFileName.push(item?.file?.name);
      }
    });
    _data["filename"] = listFileName;
    _data["tentepdinhkem"] = listName;
    _data["tepdinhkem"] = jsonPayload;
    onSubmit(_data);
  }

  const handelClear = () => {
    onClose();
  };

  useEffect(() => {
    if (validationErrors?.another) {
      setAlert({
        alert: true,
        message: validationErrors?.another,
        type: "error",
      });
    } else {
      setErrors(validationErrors);
    }
  }, [validationErrors]);

  useEffect(() => {
    if (open) {
      setErrors({});
      setValue(0);
      setFileDel([]);
      setFileFields([]);
      setFileEditName({});
    }
  }, [open]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({ alert: false, message: null, type: null });
  };

  const handleChangeDataState = (data) => {
    let { name, value } = data;
    setDataState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleErrorDataState = (error) => {
    let { name, value } = error;
    setErrors((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeMultiple = (key) => (e) => {
    let { value } = e.target;
    setDataState((prev) => ({
      ...prev,
      [key]: value?.length > 0 ? value : [],
    }));
  };
  const handleOnFocus = (name) => (e) => {
    e.stopPropagation();
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };
  const handleToDelete = (key, value) => (e) => {
    let newArr = dataState[key].filter((item) => item !== value);
    setDataState((prev) => ({
      ...prev,
      [key]: newArr || [],
    }));
  };

  //change file
  const handleErrorDownload = (error) => {
    setAlert(error);
  };
  const handleOnDeleteFileDefault = (data) => {
    setFileDel(data);
  };
  const handleErrorFile = (error) => {
    setErrors(error);
  };
  const handleChangeFileList = (data) => {
    setFileFields(data);
  };
  const handleEditFileNameDefault = (data) => {
    setFileEditName(data);
  };
  return (
    <>
      {alert.alert && (
        <Snackbar
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={alert.alert}
          onClose={handleCloseAlert}
        >
          <Alert onClose={handleCloseAlert} severity={alert.type}>
            {alert.message}
          </Alert>
        </Snackbar>
      )}
      <Dialog
        fullScreen={fullScreen}
        open={open}
        PaperComponent={PaperComponent}
        onClose={handelClear}
        scroll="paper"
        PaperProps={{
          sx: {
            "@media (min-width: 768px)": {
              minWidth: "40rem",
            },
            height: "100%",
          },
        }}
      >
        {/* Form*/}
        <form
          ref={formRef}
          method="post"
          encType="multipart/form-data"
          style={{
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            height: "100%",
          }}
        >
          {/* Tiêu đề modal - tham số title */}
          <DialogTitle sx={{ m: 0, p: 2, backgroundColor: "#ffffff" }}>
            {title ? title : "Chỉnh sửa hội đồng"}
            <IconButton
              aria-label="close"
              onClick={handelClear}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <Box
            sx={{
              width: "100%",
              bgcolor: "background.paper",
              //borderBottom: 1,
              borderColor: "divider",
              padding: "0 1rem 1rem 1rem",
            }}
          >
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="secondary"
              textColor="primary"
              variant="fullWidth"
              aria-label="basic tabs example"
            >
              <Tab
                icon={<BusinessIcon />}
                label="Thông tin"
                {...JsonTool.a11yProps(0)}
              />
              <Tab
                icon={<ArticleIcon />}
                label="Tệp đính kèm"
                {...JsonTool.a11yProps(1)}
              />
            </Tabs>
          </Box>
          <DialogContent dividers sx={{ overflow: "auto", paddingTop: "0" }}>
            <Box>
              {/* show lỗi từ khi không xác định được từ các field ở form */}
              {errors && errors.error ? (
                <Grid container sx={{ textAlign: "center", mb: 0 }}>
                  <Grid item xs={12}>
                    <Alert severity="error" sx={{ mb: 3, mt: 0 }}>
                      {errors.error}
                    </Alert>
                  </Grid>
                </Grid>
              ) : (
                ""
              )}
              <CustomTabPanel value={value} index={0}>
                {fieldInfor?.length > 0 && (
                  <CustomFieldForm
                    key={"fieldInfor"}
                    listField={fieldInfor}
                    data={dataState}
                    onChange={handleChangeDataState}
                    onError={handleErrorDataState}
                    errorValues={errors}
                    listOptionDic={{
                      maquan: dataHuyen,
                      capquanly: [
                        {
                          id: 1,
                          ten: "Cấp xã",
                        },
                        {
                          id: 2,
                          ten: "Cấp huyện",
                        },
                        {
                          id: 3,
                          ten: "Cấp tỉnh",
                        },
                      ],
                      loai: [
                        {
                          id: 1,
                          ten: "Hội đồng",
                        },
                        {
                          id: 2,
                          ten: "Tổ tư vấn",
                        },
                        {
                          id: 3,
                          ten: "Tổ thư ký Hội đồng",
                        },
                      ],
                      trangthai: [
                        {
                          id: 1,
                          ten: "Còn hiệu lực",
                        },
                        {
                          id: 2,
                          ten: "Hết hiệu lực",
                        },
                      ],
                    }}
                  />
                )}
                <Grid
                  container
                  spacing={2}
                  sx={{ textAlign: "left", marginTop: "0" }}
                >
                  <Grid item xs={12}>
                    <Typography
                      fontSize={"0.75rem"}
                      color={"#000000"}
                      fontWeight={500}
                    >
                      Thành viên <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <FormControl fullWidth>
                      <Select
                        multiple
                        sx={{ padding: "0.75rem" }}
                        name={"thanhvien"}
                        value={
                          dataThanhVien?.length > 0 &&
                          dataState &&
                          dataState.thanhvien
                            ? dataState.thanhvien
                            : []
                        }
                        MenuProps={MenuProps}
                        error={errors ? !!errors?.thanhvien : false}
                        onChange={handleChangeMultiple("thanhvien")}
                        onFocus={handleOnFocus("thanhvien")}
                        required={true}
                        renderValue={(selected) => {
                          return (
                            <Stack gap={1} direction="row" flexWrap="wrap">
                              {dataThanhVien?.length > 0 &&
                                selected?.length > 0 &&
                                selected.map((value) => (
                                  <Chip
                                    key={value}
                                    label={
                                      dataThanhVien?.find(
                                        (item) => item?.id == value
                                      )?.ten
                                    }
                                    onDelete={handleToDelete(
                                      "thanhvien",
                                      value
                                    )}
                                    deleteIcon={
                                      <CancelIcon
                                        onMouseDown={(event) =>
                                          event.stopPropagation()
                                        }
                                      />
                                    }
                                    sx={{
                                      fontSize: "0.75rem",
                                      height: "1.25rem",
                                    }}
                                  />
                                ))}
                            </Stack>
                          );
                        }}
                      >
                        <MenuItem disabled value={""}>
                          {`--- Chọn thành viên ---`}
                        </MenuItem>
                        {dataThanhVien &&
                          dataThanhVien?.length > 0 &&
                          dataThanhVien?.map((item) => (
                            <MenuItem
                              key={item?.id + "thanhvien"}
                              value={item?.id}
                            >
                              <ListItemIcon>
                                <img
                                  src={
                                    item?.anhdaidien
                                      ? API_URL + "/media/" + item?.anhdaidien
                                      : LinkImage.userDefault
                                  }
                                  width={24}
                                  height={24}
                                />
                              </ListItemIcon>
                              <Typography variant="inherit" noWrap>
                                {item?.ten}
                              </Typography>
                            </MenuItem>
                          ))}
                      </Select>
                      {errors?.thanhvien && (
                        <FormHelperText sx={{ color: "red", fontSize: "12px" }}>
                          {errors?.thanhvien}
                        </FormHelperText>
                      )}
                    </FormControl>
                  </Grid>
                </Grid>
              </CustomTabPanel>
              <CustomTabPanel value={value} index={1}>
                <AddListFile
                  dataDefault={data?.tepdinhkem_hoidong}
                  fileDel={fileDel}
                  fileEditName={fileEditName}
                  fileFields={fileFields}
                  errors={errors}
                  onDelete={handleOnDeleteFileDefault}
                  onError={handleErrorFile}
                  onFileChange={handleChangeFileList}
                  nameFile="hoidong"
                  onEditName={handleEditFileNameDefault}
                  onErrorDownload={handleErrorDownload}
                />
              </CustomTabPanel>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              color="secondary"
              type="button"
              variant="contained"
              startIcon={<Cancel />}
              size="small"
              onClick={handelClear}
              sx={{ color: "#ffffff", float: "right", mr: 1 }}
            >
              Hủy
            </Button>
            <Button
              type="submit"
              variant="contained"
              startIcon={<SaveIcon />}
              size="small"
              onClick={onSubmitForm}
              sx={{ color: "#ffffff", float: "right", mr: 1 }}
            >
              Lưu
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};

const validateRequired = (value) => {
  let result = !!value?.length;
  if (typeof value == "number") {
    result = true;
  }
  return result;
};
const validateArrayRequired = (arrayValue) => {
  let result = [];
  if (arrayValue) {
    arrayValue.map((value, index) => {
      result.push("");
      if (!value?.length) result[index] = "Tên tệp không được trống";
    });
  }
  return result;
};
const validateFileEditName = (arrayValue) => {
  let result = {};
  if (arrayValue) {
    arrayValue.map((file, index) => {
      result[file?.id] = "";
      if (!file?.tentepdinhkem) result[file?.id] = "Tên tệp không được trống";
    });
  }
  return result;
};

function validateOBJ(hd, dungluong) {
  let result = {
    soquyetdinh: !validateRequired(hd.soquyetdinh)
      ? "Số quyết định không được trống"
      : "",
    ngayky: !validateRequired(hd.ngayky)
      ? "Ngày ký rỗng hoặc định dạng sai"
      : "",
    capquanly: !validateRequired(hd.capquanly) ? "Chọn cấp quản lý" : "",
    trangthai: !validateRequired(hd.trangthai) ? "Chọn trạng thái" : "",
    trichyeu: !validateRequired(hd.trichyeu)
      ? "Trích yếu không được trống"
      : "",
    loai: !validateRequired(hd.loai) ? "Chọn loại" : "",
    thanhvien: !validateRequired(hd.thanhvien) ? "Chọn thành viên" : "",
    tentepdinhkem: validateArrayRequired(hd.tentepdinhkem),
    tepdinhkemValidate: validateArrayFileRequired(
      hd.tepdinhkemValidate,
      dungluong
    ),
    tentepdinhkemEdit: validateFileEditName(hd.tentepdinhkemEdit),
  };
  return result;
}
export default FormHoiDong;
